import request from './config'

// 用户登录
export function login(data) {
  return request({
    url: '/user/login',
    method: 'post',
    data
  })
}

// 用户退出登录
export function logout() {
  return request({
    url: '/user/logout',
    method: 'post'
  })
}

// 获取当前用户信息
export function getUserInfo() {
  return request({
    url: '/user/info',
    method: 'get'
  })
}

// 修改密码
export function changePassword(data) {
  return request({
    url: '/user/change-password',
    method: 'post',
    data
  })
}

// 获取用户配置
export function getUserConfig() {
  return request({
    url: '/user/config',
    method: 'get'
  })
}

// 重置APP Secret
export function resetAppSecret() {
  return request({
    url: '/user/config/reset-secret',
    method: 'post'
  })
}
